import request from "@/utils/request";

// 获取地区列表
export function getAreaTree(data) {
  return request({
    method: "post",
    path: "common/getAreaTree",
    data,
  });
}

// 获取底部菜单
export function getNavbar(data) {
  return request({
    method: "post",
    path: "common/navbar",
    data,
  });
}

// 发送短信
export function sendCode(data) {
  return request({
    method: "post",
    path: "common/sendCode",
    data,
  });
}

// 上传图片
export function uploadImage(data) {
  return request({
    method: "post",
    path: "common/uploadImage",
    data,
  });
}

// 上传文件
export function uploadFile(data) {
  return request({
    method: "post",
    path: "common/uploadFile",
    data,
  });
}

// 获取系统配置
export function getSystemConfig(data) {
  return request({
    method: "post",
    path: "common/getSystemConfig",
    data,
  });
}

// 获取底部菜单
export function getFooterLink(data) {
  return request({
    method: "post",
    path: "common/getFooterLink",
    data,
  });
}

// 获取配置
export function getConfig(data) {
  return request({
    method: "post",
    path: "common/getConfig",
    data,
  });
}
